import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';
import { AppContextProvider } from './context/AppContext';
import React, { useContext, Suspense } from 'react';
import Home from "./pages/Auth/Home";
import SignIn from "./pages/Auth/SignIn";
import PrivateRoute from './components/PrivateRoute'
import ScrollToTop from './components/ScrollToTop';
import Loader from './components/Loader';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import Error from './pages/Error';

import User from './pages/User/Index';
import UserView from './pages/User/View';
import UserActivityLog from './pages/User/ActivityLog';

import Product from './pages/Product/Index';
import ProductAddEdit from './pages/Product/AddEdit';
import ImportProduct from './pages/Product/ImportProduct';
import ProductView from './pages/Product/View';

import ProductPrice from './pages/ProductPrice/Index';

import Cms from './pages/Cms/Index';
import CmsAddEdit from './pages/Cms/AddEdit';

import Feedback from './pages/Feedback/Index';
import FeedbackView from './pages/Feedback/View';

import Subscription from './pages/Subscription/Index';
import SubscriptionAddEdit from './pages/Subscription/AddEdit';
import SubscriptionView from './pages/Subscription/View';

import City from './pages/City/Index';
import State from './pages/State/Index';
import Segment from './pages/Segment/Index';
import Setting from './pages/Setting/Index';
import Category from './pages/Category/Index';
import SubCategory from './pages/SubCategory/Index';
import Schemes from './pages/Schemes/Index';
import Brand from './pages/Brand/Index';
import VehicleManufacturer from './pages/VehicleManufacturer/Index';
import Vehicle from './pages/Vehicle/Index';
import VehicleModel from './pages/VehicleModel/Index';
import Catalogue from './pages/Catalogue/Index';

window.Buffer = window.Buffer || require("buffer").Buffer;

function App() {

  return (
    <AuthProvider>
      <AppContextProvider>
        <Suspense fallback={<Loader />}>
          <BrowserRouter>
            <ScrollToTop />
            <ToastContainer closeOnClick={false} />
            <AppRoutes />
          </BrowserRouter>
        </Suspense>
      </AppContextProvider>
    </AuthProvider>
  );
}

const AppRoutes = () => {

  const { isLoggedIn } = useContext(AuthContext)

  return (
    <Routes >
      <Route path="/login" element={<SignIn />} />

      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>}
      >

        {/* Auth Routes */}
        <Route exact path="/" element={<Home />} />
        <Route exact path="/dashboard" element={<Home />} />

        {/* User Routes */}
        <Route exact path="/user" element={<User />} />
        <Route exact path="/user/view/:id" element={<UserView />} />
        <Route exact path="/user/activity-logs/:id" element={<UserActivityLog />} />

        {/* Product Routes */}
        <Route exact path="/product" element={<Product />} />
        <Route exact path="/product/add" element={<ProductAddEdit />} />
        <Route exact path="/product/update/:id" element={<ProductAddEdit />} />
        <Route exact path="/product/view/:id" element={<ProductView />} />
        <Route exact path="/product/import" element={<ImportProduct />} />

        {/* Product Price Routes */}
        <Route exact path="/product-price" element={<ProductPrice />} />

        {/* CMS Routes */}
        <Route exact path="/cms" element={<Cms />} />
        <Route exact path="/cms/add-edit/:id?" element={<CmsAddEdit />} />

        {/* City Routes */}
        <Route exact path="/city" element={<City />} />

        <Route exact path="/feedback" element={<Feedback />} />
        <Route exact path="/feedback/view/:id" element={<FeedbackView />} />
        {/* Vehicle Model Routes */}

        {/* Brand Routes */}
        <Route exact path="/brand" element={<Brand />} />
        {/* Vehicle Manufacturer Routes */}
        <Route exact path="/vehicle-manufacturer" element={<VehicleManufacturer />} />
        {/* Vehicle Routes */}
        <Route exact path="/vehicle" element={<Vehicle />} />
        {/* Vehicle Model Routes */}
        <Route exact path="/vehicle-model" element={<VehicleModel />} />
        {/* Category Routes */}
        <Route exact path="/category" element={<Category />} />
        {/* Sub Category Routes */}
        <Route exact path="/sub-category" element={<SubCategory />} />
        {/* Catalogue Routes */}
        <Route exact path="/catalogue" element={<Catalogue />} />

        {/* State Routes */}
        <Route exact path="/state" element={<State />} />

        {/* Segment Routes */}
        <Route exact path="/segment" element={<Segment />} />

        {/* Schemes Routes */}
        <Route exact path="/schemes" element={<Schemes />} />

        {/* Tag Routes */}
        <Route exact path="/setting" element={<Setting />} />

        {/* Subscription Routes */}
        <Route exact path="/subscription" element={<Subscription />} />
        <Route exact path="/subscription/add" element={<SubscriptionAddEdit />} />
        <Route exact path="/subscription/update/:id" element={<SubscriptionAddEdit />} />
        <Route exact path="/subscription/view/:id" element={<SubscriptionView />} />

      </Route >

      <Route path="*" element={<Error />} />
    </Routes >
  )
}

const Layout = () => {
  return (<> <Outlet />  </>
  )
}

export default App;